import { createFileRoute } from '@tanstack/react-router';
import { LeaveHub } from '@/features/leave/LeaveHub';

export const Route = createFileRoute('/_app/leave/new')({ component: LeaveNewPage });

/** Nuova richiesta: apre il drawer di creazione dentro il LeaveHub (desktop e mobile). */
function LeaveNewPage() {
  return <LeaveHub openCreate />;
}
